import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { AppState } from '@app/reducers';
import { AgentLoginService, agentLoginDataSelector } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, SharedModuleApiSuffixModels, addFormControls, countryCodes, formConfigs, getPDropdownData, prepareGetRequestHttpParams, removeFormControls, setRequiredValidator } from '@app/shared/utils';
import { MediaTypes } from '@modules/my-tasks/components/email-dashboard/media-type.enums';
import { loggedInUserData } from '@modules/others';
import { ScheduleCallBackAddEditModel } from '@modules/sales/models/lead-sms-notification.model';
import { SalesModuleApiSuffixModels } from '@modules/sales/shared';
import { Store, select } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { Observable, combineLatest } from 'rxjs';
@Component({
  selector: 'app-schedule-callback-add-edit',
  templateUrl: './schedule-callback-add-edit-modal.component.html',
  styleUrls: ['./lead-notes.scss'],
})
export class ScheduleCallbackAddEditModalComponent implements OnInit {
  scheduleCallbackForm: FormGroup;
  formConfigs = formConfigs;
  countryCodes = countryCodes;
  loggedInUserData: LoggedInUserModel;
  ticketReferences = [];
  customerData: any = [];
  todayDate = new Date();
  queues = [];
  agentExtensionNo = '';
  @ViewChild("input", { static: false }) row;
  addressId: string = '';
  callbackDetails;
  scheduleCallBackAddEditModel: ScheduleCallBackAddEditModel;

  constructor(private formBuilder: FormBuilder, public ref: DynamicDialogRef, public config: DynamicDialogConfig,
    private crudService: CrudService, private activatedRoute: ActivatedRoute,
    private store: Store<AppState>, private rxjsService: RxjsService, private agentLoginService: AgentLoginService) {
    this.scheduleCallBackAddEditModel = config?.data;
    this.activatedRoute.queryParamMap.subscribe((params) => {
      this.addressId = params['params']['addressId'] || this.scheduleCallBackAddEditModel?.addressId
    });
  }

  ngOnInit() {
    this.combineLatestNgrxStoreData();
    if (!this.agentExtensionNo) {
      this.agentLoginService.openOpenscapeLoginPopup();
      this.ref.close(false);
    }
    this.rxjsService.setDialogOpenProperty(true);
    this.rxjsService.getCustomerDate()
      .subscribe(data => {
        this.customerData = data;
        if (this.scheduleCallBackAddEditModel?.isCustomer) {
          this.rxjsService.setLeadNotesUpdateStatus(false);
          if (data?.customerId) {
            this.getTicketReferences(data.customerId);
          }
        }
      });
    this.createScheduleAddForm();
    this.onFormControlChanges();
    this.getCustomerCallbackDetails();
  }

  getCustomerCallbackDetails() {
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.CUSTOMER_CALLBACK_DETAILS, null, null, prepareGetRequestHttpParams(null, null, { customerId: this.customerData.customerId, addressId: this.addressId }))
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          this.callbackDetails = response?.resources;
          if (this.callbackDetails) {
            this.scheduleCallbackForm
              .get("callbackDateTime").setValue(new Date(this.callbackDetails?.callbackDateTime));
            this.scheduleCallbackForm
              .get("comments").setValue(this.callbackDetails?.comments);
              this.scheduleCallbackForm
              .get("contactNumberCountryCode").setValue(this.callbackDetails?.contactNumberCountryCode);
              this.scheduleCallbackForm
              .get("contactNumber").setValue(this.callbackDetails?.contactNumber);
            this.scheduleCallbackForm
              .get("ticketId").setValue(this.callbackDetails?.ticketId);
            this.scheduleCallbackForm
              .get("isSelf").setValue(this.callbackDetails?.isSelf);
            if (!this.callbackDetails?.isSelf) {
              this.scheduleCallbackForm
                .get("queueId").setValue(this.callbackDetails?.queueId);
            }
          }

        }
      });
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData)]
    ).subscribe((response) => {
      this.loggedInUserData = response[0];
    });
    this.store.pipe(select(agentLoginDataSelector)).subscribe((extension: string) => {
      this.agentExtensionNo = extension;
    });
  }

  onFormControlChanges(): void {
    this.scheduleCallbackForm.get('isSelf').valueChanges.subscribe((isSelf: boolean) => {
      if (isSelf) {
        this.scheduleCallbackForm = removeFormControls(this.scheduleCallbackForm, ['queueId']);
      }
      else {
        this.getQueues();
        this.scheduleCallbackForm = addFormControls(this.scheduleCallbackForm, [{
          controlName: 'queueId', defaultValue: ''
        }]);
        this.scheduleCallbackForm = setRequiredValidator(this.scheduleCallbackForm, ['queueId']);
      }
    });
    this.scheduleCallbackForm
      .get("contactNumberCountryCode")
      .valueChanges.subscribe((contactNumberCountryCode: string) => {
        this.setPhoneNumberLengthByCountryCode(contactNumberCountryCode);
        this.focusAndBlurContactNumberInputField();
      });
    this.scheduleCallbackForm
      .get("contactNumber")
      .valueChanges.subscribe((mobileNumber2: string) => {
        this.setPhoneNumberLengthByCountryCode(
          this.scheduleCallbackForm.get("contactNumberCountryCode").value
        );
      });
  }

  focusAndBlurContactNumberInputField() {
    setTimeout(() => {
      this.row.nativeElement.focus();
      this.row.nativeElement.blur();
    }, 100);
  }

  getQueues() {
    this.crudService.get(
      ModulesBasedApiSuffix.SHARED,
      SharedModuleApiSuffixModels.UX_QUEUES,
      undefined,
      false,
      prepareGetRequestHttpParams(null, null, { mediaTypeId: MediaTypes.CALLBACK }))
      .subscribe((response: IApplicationResponse) => {
        if (response.resources && response.statusCode == 200 && response.isSuccess) {
          this.queues = getPDropdownData(response.resources);
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  createScheduleAddForm(): void {
    this.scheduleCallBackAddEditModel.ticketId = null;
    let scheduleCallBackAddEditModel = new ScheduleCallBackAddEditModel(this.scheduleCallBackAddEditModel);
    this.scheduleCallbackForm = this.formBuilder.group({});
    Object.keys(scheduleCallBackAddEditModel).forEach((key) => {
      this.scheduleCallbackForm.addControl(key, new FormControl(scheduleCallBackAddEditModel[key]));
    });
    this.scheduleCallbackForm = setRequiredValidator(this.scheduleCallbackForm, ["callbackDateTime", "contactNumber",
      "isSelf"]);
    this.focusAndBlurContactNumberInputField();
  }

  setPhoneNumberLengthByCountryCode(contactNumberCountryCode: string) {
    switch (contactNumberCountryCode) {
      case "+27":
        this.scheduleCallbackForm.get('contactNumber').setValidators([Validators.required, Validators.minLength(formConfigs.southAfricanContactNumberMaxLength),
        Validators.maxLength(formConfigs.southAfricanContactNumberMaxLength)]);
        break;
      default:
        this.scheduleCallbackForm.get('contactNumber').setValidators([Validators.required, Validators.minLength(formConfigs.indianContactNumberMaxLength),
        Validators.maxLength(formConfigs.indianContactNumberMaxLength)]);
        break;
    }
  }

  getTicketReferences(id) {
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.TICKETS_CUSTOMER, null, null, prepareGetRequestHttpParams(null, null, { customerId: id }))
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode == 200) {
          this.ticketReferences = response.resources;
        }
      });
  }

  onSubmit(): void {
    if (this.scheduleCallbackForm.invalid) {
      return;
    }
    let payload = this.scheduleCallbackForm.value;
    payload.contactNumber =
      payload.contactNumber.replace(/[a-z]/gi, '').replace(/ /g, '');
    payload.createdUserId = this.loggedInUserData.userId;
    var date = new Date(payload.callbackDateTime);
    var dateStr =
      ("00" + (date.getMonth() + 1)).slice(-2) + "/" +
      ("00" + date.getDate()).slice(-2) + "/" +
      date.getFullYear() + " " +
      ("00" + date.getHours()).slice(-2) + ":" +
      ("00" + date.getMinutes()).slice(-2) + ":" +
      ("00" + date.getSeconds()).slice(-2);
    payload.callbackDateTime = dateStr;
    payload.pabxId = this.loggedInUserData.openScapePabxId;
    if (payload.ticketId && payload.ticketId == 'null') {
      payload.ticketId = null;
    }
    let crudService: Observable<IApplicationResponse> = this.crudService.create(ModulesBasedApiSuffix.SALES,
      this.scheduleCallBackAddEditModel?.isCustomer ?
        SalesModuleApiSuffixModels.CUSTOMER_CALLBACK : SalesModuleApiSuffixModels.SALES_API_LEAD_CALLBACK,
      payload)
    crudService.subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode == 200) {
        this.rxjsService.setLeadNotesUpdateStatus(true);
        this.ref.close(true);
      }
    });
  }

  dialogClose(): void {
    this.ref.close(false);
  }

  ngOnDestroy() {
    this.rxjsService.setDialogOpenProperty(false);
  }
}
